import { render } from "./TgButton.vue?vue&type=template&id=d3310a2c&scoped=true&ts=true"
import script from "./TgButton.vue?vue&type=script&lang=ts"
export * from "./TgButton.vue?vue&type=script&lang=ts"

import "./TgButton.vue?vue&type=style&index=0&id=d3310a2c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3310a2c"]])

export default __exports__